import React from 'react';
import { observer } from 'mobx-react';
import { DesiccantDryerConnectivityIcon } from '../DesiccantDryerConnectivityIcon';
import { DesiccantDetailsViewContainer } from './DesiccantDetailsView.styles';

export const DessicantDetailsView = observer(({ node }) => {
  const { connectivity, connectionType, dryerExtendedActivity } = node.getEntity();

  return (
    <DesiccantDetailsViewContainer>
      <div className="header">
        <DesiccantDryerConnectivityIcon
          connectivity={connectivity}
          connectionType={connectionType}
          dryerExtendedActivity={dryerExtendedActivity}
        />
      </div>
    </DesiccantDetailsViewContainer>
  );
});
